import { render, staticRenderFns } from "./CompactSideBar.vue?vue&type=template&id=42619d06&scoped=true&"
import script from "./CompactSideBar.vue?vue&type=script&lang=js&"
export * from "./CompactSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CompactSideBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompactSideBar.vue?vue&type=style&index=1&id=42619d06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42619d06",
  null
  
)

export default component.exports